import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const SmartLink = ({ to, ...props }) => {
  if (/^\//.test(to)) {
    return <Link to={to} {...props} />;
  }

  return (
    // eslint-disable-next-line
    <a href={to} {...props} />
  );
};

SmartLink.propTypes = {
  to: PropTypes.string,
};

export default SmartLink;
